export default "./dist/stdassets/images/icons/folder-horizontal.png";